export interface BaseResponse {
  created: number;
  updated: number;
}
export interface PaymentSuccessResponse {
  success: boolean;
  message: string;
}

export const allFontWeights = ['100', '200', '300', '400', '500', '600', '700', 'Bold'];
